import { all_states } from '../../../components/abha/util';
import { UPDATE_ABHA_INCENTIVE_STATUS } from '../../constants';
import fetchWithRefresh from '../../fetchWithRefresh';
import { IncentiveIssues, dhis_states } from '../../getAbhaMetricsDashboard';

interface Body {
    state_id?: all_states;
    issue?: IncentiveIssues;
    month?: string;
    cid: string;
    dhisstatus?: dhis_states;
    dhisissues?: IncentiveIssues;
}

interface Response {
    success: boolean;
    error?: string;
}

export const updateIncentiveStatus = (body: Body): Promise<Response> => {
    return fetchWithRefresh(UPDATE_ABHA_INCENTIVE_STATUS, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res.json());
};
